import { SortDescriptor } from "@progress/kendo-data-query";

export class PaginationRequestBase {
  skip?: number;
  pageSize?: number;
  sort: SortDescriptor[] = [];
}